// Vanilla snackbar for SSR pages that don't load the React bundle.
// Visuals mirror assets/react/shared/components/Snackbar.tsx.

const AUTO_DISMISS_MS = 4000

type SnackbarVariant = 'success' | 'error'

const ICONS: Record<SnackbarVariant, string> = {
  success: `<svg class="h-5 w-5 shrink-0 text-green-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg>`,
  error: `<svg class="h-5 w-5 shrink-0 text-red-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" /></svg>`,
}

const X_MARK_ICON = `<svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>`

function getContainer(): HTMLElement {
  const existing = document.getElementById('ts__snackbar_container')
  if (existing) {
    return existing
  }

  const container = document.createElement('div')
  container.id = 'ts__snackbar_container'
  container.className =
    'fixed bottom-4 left-1/2 flex w-full max-w-sm -translate-x-1/2 flex-col gap-2 px-4'
  container.style.zIndex = '9999'
  document.body.appendChild(container)

  return container
}

export function showSnackbar(variant: SnackbarVariant, message: string) {
  const container = getContainer()

  const card = document.createElement('div')
  card.setAttribute('role', variant === 'error' ? 'alert' : 'status')
  card.className =
    'flex items-center gap-3 rounded-lg bg-gray-900 px-4 py-3 text-sm text-white shadow-lg'

  const messageElement = document.createElement('span')
  messageElement.className = 'flex-1'
  messageElement.textContent = message

  const dismissButton = document.createElement('button')
  dismissButton.type = 'button'
  dismissButton.className = 'shrink-0 text-gray-400 hover:text-white focus:outline-none'
  dismissButton.innerHTML = X_MARK_ICON
  dismissButton.addEventListener('click', () => card.remove())

  card.innerHTML = ICONS[variant]
  card.appendChild(messageElement)
  card.appendChild(dismissButton)
  container.appendChild(card)

  setTimeout(() => card.remove(), AUTO_DISMISS_MS)
}
